import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  FaAd,
  FaBriefcase,
  FaCalendarAlt,
  FaHome,
  FaUser,
  FaChartBar,
  FaCog,
  FaCheckCircle,
  FaTimesCircle,
} from 'react-icons/fa'
import { MdOutlineSupportAgent } from 'react-icons/md'
import { BsImages } from 'react-icons/bs'

interface DashboardMenuProps {
  userStatus: string[]
  isLoading: boolean
  verifiedStatus?: string
}

const DashboardMenu: React.FC<DashboardMenuProps> = ({
  userStatus,
  isLoading,
  verifiedStatus,
}) => {
  const { t } = useTranslation()
  const location = useLocation()

  if (isLoading) return <div>Loading...</div>

  const isActive = (link: string) => {
    if (link === '/') {
      return false
    }
    if (link === '/dashboard/') {
      return location.pathname === link
    }
    if (link === '/dashboard/events/') {
      return (
        location.pathname.startsWith(link) ||
        location.pathname.includes('announce-event/')
      )
    }
    if (link === '/dashboard/announces/') {
      return (
        location.pathname.startsWith(link) ||
        location.pathname.includes('announce/')
      )
    }
    if (link === '/dashboard/job-offers/') {
      return (
        location.pathname.startsWith(link) ||
        location.pathname.includes('announce-work')
      )
    }
    if (link === '/dashboard/announces-libertin/') {
      return (
        location.pathname.startsWith(link) ||
        location.pathname.includes('announce-libertin/')
      )
    }
    if (link === '/dashboard/announces-establishment/') {
      return (
        location.pathname.startsWith(link) ||
        location.pathname.includes('announce-establishment/')
      )
    }
    if (link === '/dashboard/announces-libertin/') {
      return (
        location.pathname.startsWith(link) ||
        location.pathname.includes('announce/')
      )
    }
    return location.pathname.startsWith(link)
  }

  let menuItems = [
    { label: t('dashboard.dashboard'), link: '/dashboard/', icon: <FaHome /> },
    {
      label: t('dashboard.my-gallery'),
      link: '/dashboard/my-gallery/',
      icon: <BsImages />,
    },
  ]

  if (userStatus.includes('private, escort, massage')) {
    menuItems.push({
      label: t('dashboard.profile'),
      link: '/dashboard/profile/',
      icon: <FaUser />,
    })
    menuItems.push({
      label: t('dashboard.verified-status'),
      link: '/dashboard/verify-status/',
      icon:
        verifiedStatus === 'verified' ? (
          <FaCheckCircle style={{ color: '#25D366' }} />
        ) : verifiedStatus === 'denied' ? (
          <FaTimesCircle style={{ color: '#ff005a' }} />
        ) : (
          <FaCheckCircle style={{ color: '#FFF' }} />
        ),
    })
    menuItems.push({
      label: t('create-ad.announce'),
      link: '/dashboard/announces/',
      icon: <FaAd />,
    })
    menuItems.push({
      label: t('dashboard.statistics'),
      link: '/dashboard/statistics/',
      icon: <FaChartBar />,
    })
    menuItems.push({
      label: t('create-ad.events'),
      link: '/dashboard/events/',
      icon: <FaCalendarAlt />,
    })
    menuItems.push({
      label: t('create-ad.jobs'),
      link: '/dashboard/job-offers/',
      icon: <FaBriefcase />,
    })
    menuItems.push({
      label: t('dashboard.account-settings'),
      link: '/dashboard/settings/',
      icon: <FaCog />,
    })
    menuItems.push({
      label: t('dashboard.support'),
      link: '/dashboard/support/',
      icon: <MdOutlineSupportAgent />,
    })
  }

  if (userStatus.includes('libertins ou visiteur')) {
    menuItems.push({
      label: t('dashboard.profile'),
      link: '/dashboard/profile/',
      icon: <FaUser />,
    })
    menuItems.push({
      label: t('create-ad.announce'),
      link: '/dashboard/announces-libertin/',
      icon: <FaAd />,
    })
    menuItems.push({
      label: t('dashboard.statistics'),
      link: '/dashboard/statistics/',
      icon: <FaChartBar />,
    })
    menuItems.push({
      label: t('dashboard.account-settings'),
      link: '/dashboard/settings/',
      icon: <FaCog />,
    })
    menuItems.push({
      label: t('dashboard.support'),
      link: '/dashboard/support/',
      icon: <MdOutlineSupportAgent />,
    })
  }

  if (
    userStatus.includes(
      'maison privee, bars et clubs prive, salons de massage, hotels coquins, saunas prives, clubs echangistes, event',
    )
  ) {
    menuItems.push({
      label: t('create-ad.announce'),
      link: '/dashboard/announces-establishment/',
      icon: <FaAd />,
    })
    menuItems.push({
      label: t('dashboard.statistics'),
      link: '/dashboard/statistics/',
      icon: <FaChartBar />,
    })
    menuItems.push({
      label: t('create-ad.events'),
      link: '/dashboard/events/',
      icon: <FaCalendarAlt />,
    })
    menuItems.push({
      label: t('create-ad.jobs'),
      link: '/dashboard/job-offers/',
      icon: <FaBriefcase />,
    })
    menuItems.push({
      label: t('dashboard.account-settings'),
      link: '/dashboard/settings/',
      icon: <FaCog />,
    })
    menuItems.push({
      label: t('dashboard.support'),
      link: '/dashboard/support/',
      icon: <MdOutlineSupportAgent />,
    })
  }

  if (userStatus.includes('job_offer')) {
    menuItems.push({
      label: t('dashboard.job-offers'),
      link: '/dashboard/job-offers/',
      icon: <FaBriefcase />,
    })
  }

  if (userStatus.includes('event')) {
    menuItems.push({
      label: t('dashboard.events'),
      link: '/dashboard/events/',
      icon: <FaCalendarAlt />,
    })
  }

  return (
    <>
      <ul className='mb-8'>
        {menuItems.map((item, index) => (
          <li key={index}>
            <Link
              to={item.link}
              className={`block py-2 px-4 text-white transition-all text-sm ${
                isActive(item.link) ? 'bg-redpink' : 'hover:bg-anthraciteLight'
              } border-b border-anthraciteLight border-dotted`}
            >
              <span className='flex items-center'>
                <span className='mr-4'>{item.icon}</span>
                {item.label}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </>
  )
}

export default DashboardMenu
